import { render } from "./DataMapperStreaming.vue?vue&type=template&id=a023a0f8&scoped=true"
import script from "./DataMapperStreaming.vue?vue&type=script&lang=js"
export * from "./DataMapperStreaming.vue?vue&type=script&lang=js"

import "./DataMapperStreaming.vue?vue&type=style&index=0&id=a023a0f8&lang=scss&scoped=true"
import "./DataMapperStreaming.vue?vue&type=style&index=1&id=a023a0f8&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a023a0f8"]])

export default __exports__